function Header() {
  return (
    <header>
     <video src={process.env.PUBLIC_URL + '/Video1.mp4'} loop autoPlay muted></video>

     <div class="typewriter">
  <h1>Creating Solutions, Crafting Success.</h1>
</div>
      <div className="row">
        <button className="btn" style={{ cursor: "pointer" }} >
          Contact Us
          
        </button>

        
      </div>

      <div className="headerbg"></div>
    </header>
  );
}
export default Header;
